module.exports = __webpack_public_path__ + "static/media/tom.b5adb36c.jpg";